import React, {useEffect, useState} from 'react';
import Header from '../component/Header'
import SubBanner from '../component/SubBanner'
import LegalContnet from '../component/LegalContnet'
import Footer from '../component/Footer'
import '../scss/legal-contnet.scss'
import '../scss/sub-banner.scss'
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

function TermsCondition() {

  const [pageData, setPageData] = useState(null);
  const [pageName, setPageName] = useState("");
  const { pageResponse } = useSelector((state) => state.visitor);

  useEffect(() => {
    if (pageResponse) {
      let p = pageResponse.find((r) => r.code === "terms-conditions");
      setPageData(p.page_description);
      setPageName(p.page_name);
    }
  }, [pageResponse]);
  return (
    <>
     <Helmet>
        <title>Helpotani | {pageName}</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>
      <main className='main home-page'>
        <Header />   
        <SubBanner HeaderTitle={pageName} />
        <LegalContnet page={pageName} data={pageData} />
      </main>
      <Footer />
    </>
  )
}
export default TermsCondition 


